import {
    SET_STATES,
    SET_EDIT_STATE,
    SET_NEW_STATE,
    SET_DELETE_STATE,
    SET_DELETE_MULTI_STATE,
    SET_LIST_STATES,
    SET_STATE,
    RESET_ITEMS_STATE,
    RESET_LIST_STATES,
} from "redux/constants/States";

const initalAgreementState = {
    items: [],
    list: [],
    selected: {},
    loading: true,
};
const States = (state = initalAgreementState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_STATES: {
            return { ...state, items: payload, loading: false };
        }
        case SET_LIST_STATES: {
            return { ...state, list: payload };
        }
        case SET_STATE: {
            return { ...state, selected: payload };
        }
        case SET_NEW_STATE: {
            return { ...state, items: [payload, ...state.items] };
        }

        case SET_EDIT_STATE: {
            let list = [...state.items];

            try {
                let ind = list.findIndex((item) => item.id === payload.id);

                if (ind > -1) {
                    list[ind] = payload;
                }
            } catch (error) {}

            return { ...state, items: list };
        }

        case SET_DELETE_STATE: {
            let list = state.items.filter((item) => item._id !== payload);

            return { ...state, items: list };
        }

        case SET_DELETE_MULTI_STATE: {
            let arr = payload.split(",");
            let list = state.items.filter((item) => !arr.includes(item._id));

            return { ...state, items: list };
        }

        case RESET_LIST_STATES: {
            return { ...state, list: [] };
        }
        case RESET_ITEMS_STATE: {
            return { ...state, items: [], loading: true };
        }

        default:
            return state;
    }
};

export default States;
